import { css } from "styled-components";
import { color, size, spacing } from "../tokens/ts/variables";
export const rootStyles = css `
  :host,
  :root,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  input,
  input:-webkit-autofill::first-line,
  input:-webkit-autofill {
    &:not(:where([class*="flow--"])) {
      font-weight: normal;
      font-style: normal;
      font-size: ${size.font.text};
      font-family: inherit;

      color: ${color.font.text.default};

      text-rendering: geometricPrecision;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
    }
  }

  :host,
  :root {
    &:not(:where([class*="flow--"])) {
      font-family: "MW-Flow-Regular";
    }
  }

  a:not(:where([class*="flow--"])) {
    font-family: inherit;
    text-decoration: inherit;
    color: inherit;
    cursor: pointer;
  }

  input,
  button {
    &:not(:where([class*="flow--"])) {
      font-family: inherit;
      margin: 0;
    }
  }

  pre:not(:where([class*="flow--"])) {
    font-family: "MW-Flow-Mono", monospace;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  ol,
  ul {
    &:not(:where([class*="flow--"])) {
      margin: 0;
      padding: 0;
      font-weight: normal;
    }
  }

  ol,
  ul {
    &:not(:where([class*="flow--"])) {
      padding-left: ${spacing.base.l};
    }
  }

  li {
    &:not(:where([class*="flow--"])) {
      margin-bottom: ${spacing.base.s};
      padding-left: ${spacing.base.s};
    }
  }

  ol.unstyled,
  ul.unstyled {
    &:not(:where([class*="flow--"])) {
      list-style: none;
      padding-left: 0;

      & li {
        padding-left: 0;
      }
    }
  }

  img:not(:where([class*="flow--"])) {
    max-width: 100%;
    height: auto;
  }

  *:not(:where([class*="flow--"])) {
    /* This avoids wired artefacts when using rounded borders with background color (e.g. Banners)*/
    border: transparent;
  }

  iframe:not(:where([class*="flow--"])) {
    display: none;
  }
`;
export default rootStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicm9vdFN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvcm9vdFN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFDeEMsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLE1BQU0sd0JBQXdCLENBQUM7QUFFOUQsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLEdBQUcsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7O21CQWVWLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSTs7O2VBR2xCLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O3NCQXFEaEIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDOzs7Ozs7dUJBTWIsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO3NCQUNmLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0E2Qm5DLENBQUM7QUFFRixlQUFlLFVBQVUsQ0FBQyJ9